module.exports = __webpack_public_path__ + "static/antd-table-highlight-0fd575ca2f2ad52e3269fca0a5474141.png";